import { useEffect, useState } from "react";
import { Layout, Button, Card, Tabs, Spin, Flex } from "antd";
import { ReloadOutlined, RollbackOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import { getAPI, postAPI } from "../../utils/common";
import {
  STAFF,
  ALL_SUBSCRIPTION_PLAN,
  ALL_FACILITY,
  VENDOR_BY_ID,
  LEAD_BY_ID,
} from "../../constants/api";
import VendorProfileTab from "./widgets/VendorProfileTab";
import VendorHotelRoomsTab from "./widgets/VendorHotelRoomsTab";
import VendorDocumentsTab from "./widgets/VendorDocumentsTab";
import { BILL_BLOCK_SYSTEM, BILL_DUE_WARNING } from "../../constants/constent";

const { Content } = Layout;

/* ================= COMPONENT ================= */

function ManageVendor() {
  const navigate = useNavigate();
  const { edit_id, type } = useParams();

  const [loading, setLoading] = useState(false);
  const [id, setEditId] = useState(edit_id);
  const [vendor, setVendorDetail] = useState(null);
  const [currentTab, setCurrentTab] = useState("1");
  const [bdes, setBdes] = useState([]);
  const [plans, setPlans] = useState([]);
  const [facility, setFacility] = useState([]);

  /* ================= INIT ================= */

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchVendorDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const init = async () => {
    fetchBDEs();
    fetchPlans();
    fetchFacility();
  };

  const handleTabChange = (value) => {
    setCurrentTab(value);
  };

  /* ================= API CALLS ================= */

  const fetchVendorDetail = () => {
    if (id) {
      setLoading(true);
      postAPI(
        type === "lead" ? LEAD_BY_ID : VENDOR_BY_ID,
        { id },
        ({ status, data }) => {
          if (status && data) {
            if (type === "lead") {
              setVendorDetail({
                sales_man_id: data?.assigned_to?.id,
                vendor_name: data?.contact_person,
                hotel_name: data?.hotel_name,
                hotel_contact_person: data?.contact_person,
                hotel_whatsapp_no: data?.phone,
                hotel_mobile_no: data?.phone,
                hotel_email_id: data?.email,
                hotel_area: data?.area,
                hotel_city_id: data?.city_id,
                hotel_state_id: data?.state_id,
                hotel_country_id: data?.country_id,
                hotel_type: data?.property_type,
                bill_due_reminder_in_day: BILL_DUE_WARNING,
                bill_due_block_system_in_day: BILL_BLOCK_SYSTEM,
              });
            } else {
              setVendorDetail(data);
            }
          }
          setLoading(false);
        },
        () => {
          setLoading(false);
        },
      );
    }
  };
  const fetchBDEs = () => {
    getAPI(STAFF, ({ status, data }) => {
      if (status) {
        const list = data.filter((u) => u.user_type === "bde");
        setBdes(list);
      }
    });
  };

  const fetchPlans = () => {
    getAPI(ALL_SUBSCRIPTION_PLAN, ({ status, data }) => {
      if (status) setPlans(data);
    });
  };

  const fetchFacility = () => {
    getAPI(ALL_FACILITY, ({ status, data }) => {
      if (status) setFacility(data);
    });
  };

  /* ================= JSX ================= */
  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="On-Boarding Vendor"
          extra={
            <>
              <Flex wrap gap="small">
                <Button
                  ghost
                  type="primary"
                  loading={loading}
                  disabled={loading}
                  onClick={() => fetchVendorDetail()}
                >
                  <ReloadOutlined />
                </Button>
                <Button
                  ghost
                  type="primary"
                  loading={loading}
                  disabled={loading}
                  onClick={() => navigate(-1)}
                >
                  <RollbackOutlined />
                </Button>
              </Flex>
            </>
          }
        >
          <Spin spinning={loading}>
            <Tabs type="card" defaultActiveKey={currentTab}>
              {/* ================= TAB 1 ================= */}
              <Tabs.TabPane tab="Vendor Profile" key="1">
                <VendorProfileTab
                  bdes={bdes}
                  plans={plans}
                  edit_id={id && type === "lead" ? null : id}
                  handleTabChange={handleTabChange}
                  setEditId={setEditId}
                  vendor={vendor}
                  fetchVendorDetail={fetchVendorDetail}
                />
              </Tabs.TabPane>
              {/* ================= TAB 2 ================= */}
              <Tabs.TabPane
                tab="Hotel Rooms"
                key="2"
                disabled={id && type !== "lead" ? false : true}
              >
                <VendorHotelRoomsTab
                  facility={facility}
                  edit_id={id && type === "lead" ? null : id}
                  handleTabChange={handleTabChange}
                  vendor={vendor}
                  fetchVendorDetail={fetchVendorDetail}
                />
              </Tabs.TabPane>

              {/* ================= TAB 3 ================= */}
              <Tabs.TabPane
                tab="Documents"
                key="3"
                disabled={id && type !== "lead" ? false : true}
              >
                <VendorDocumentsTab
                  facility={facility}
                  edit_id={id && type === "lead" ? null : id}
                  handleTabChange={handleTabChange}
                  vendor={vendor}
                  fetchVendorDetail={fetchVendorDetail}
                />
              </Tabs.TabPane>
            </Tabs>
          </Spin>
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}
export default ManageVendor;
